import React, { useState, useEffect } from "react";
import CitiesList from "./citiesList";
import DashboardLayout from "../DashboardLayout";
import {
  fetchCitiesList,
  fetchCountriesList,
} from "../../services/axios/apiManager";
import { useAppContext } from "../../services/context";
import { handleErrors } from "../../services/dataManager";
import LoadingSpinner from "../../Components/spinner";
import { useSearchParams } from "react-router-dom";

const Cities = ({ navigate }) => {
  const { state } = useAppContext();
  const { permissions } = state;
  const [searchParams] = useSearchParams();
  const [cities, setCities] = useState([]);
  const [countries, setCountries] = useState([]);
  const [pagination, setPagination] = useState({});
  const [granted, setGranted] = useState([]);
  const [loading, setLoading] = useState(true);

  const extractPermissions = () => {
    const perms = permissions.filter((f) => f.module === "Cities");
    if (perms) {
      setGranted(perms);
    }
  };

  const getCities = async () => {
    const page = searchParams.get("page") || 1;
    const search = searchParams.get("search") || "";
    const status = searchParams.get("status");

    let filterString = "";
    if (search) filterString += `&search=${encodeURIComponent(search)}`;
    if (status && status !== "3") filterString += `&status=${status}`;

    const res = await fetchCitiesList(
      page,
      pagination.pageSize || 10,
      filterString,
    );
    if (res?.data?.success && res?.data?.data) {
      setCities(res.data.data);
      if (res?.data?.pagination) {
        setPagination(res.data.pagination);
      }
    } else {
      handleErrors(res, navigate, "Cities List:");
    }
    setLoading(false);
  };

  const getCountries = async () => {
    const res = await fetchCountriesList(1, 1000);
    if (res?.data?.success && res?.data?.data) {
      setCountries(res.data.data);
    } else {
      handleErrors(res, navigate, "Countries:");
    }
  };

  useEffect(() => {
    extractPermissions();
    getCountries();
  }, []);

  useEffect(() => {
    getCities();
  }, [searchParams]);

  return (
    <DashboardLayout>
      <div data-testid="city">
        <div className="row">
          <div className="col-12 mb-3">
            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
              <div className="page-title-right">
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item">
                    <a>System Settings</a>
                  </li>
                  <li
                    className="breadcrumb-item active"
                    style={{ color: "#d1cdcdbf" }}
                  >
                    Cities
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          {loading ? (
            <div className="container justify-content-center align-item-center flex">
              <LoadingSpinner size={"lg"} />
            </div>
          ) : (
            <CitiesList
              cities={cities}
              countries={countries}
              pagination={pagination}
              setCities={setCities}
              setPagination={setPagination}
              granted={granted}
            />
          )}
        </div>
      </div>
    </DashboardLayout>
  );
};
export default Cities;
